import {Injectable, OnDestroy, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ParentAPIService} from "../parent.api.service";
import {TableRecordResult} from "../../model/api/table-record-result";
import {ApiValidation} from "../../model/api/api-validation";
import {Observable} from "rxjs";
import {CrystalclearArchiveBackUrl} from "../config/crystalclear-archive-back-url";
import {ReportTask} from "../../model/archive/report-task";
import {ApiFileResponse} from "../../model/api/api-file-response";
import {ReportTaskLoadRequest} from "../../model/archive/report-task-load-request";
import {SimpleRequest} from "../../model/api/simple-request";

@Injectable({
  providedIn: 'root'
})
export class ReportTaskService extends ParentAPIService implements OnInit, OnDestroy {


  constructor(http: HttpClient) {
    super(http);
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
  }

  public list(request: ReportTaskLoadRequest): Observable<TableRecordResult<ReportTask>> {
    return this.post(CrystalclearArchiveBackUrl.GET_ARCHIVE_TASK_LIST, request);
  }

  public check(taskId: string): Observable<ApiValidation<ReportTask>> {
    return this.post(CrystalclearArchiveBackUrl.GET_ARCHIVE_TASK_CHECK, new SimpleRequest(taskId));
  }

  public download(taskId: string): Observable<ApiFileResponse> {
    return this.post(CrystalclearArchiveBackUrl.GET_ARCHIVE_TASK_DOWNLOAD, new SimpleRequest(taskId));
  }

}
